<div class="overlay" [class.active]="isOpen" (click)="onClose()"></div>

<div class="thankyou-popup thankyou-popup_pos" [class.active]="isOpen">
  <div class="thankyou-popup__icon-wrapper">
    <img src="assets/img/icons/cancel.svg" alt="Thank you modal:Success icon" class="thankyou-popup__icon" />
  </div>

  <h3 class="thankyou-popup__title">Error!</h3>

  <p class="thankyou-popup__description">{{ message }}</p>

  <button (click)="onClose()" class="btn btn_soft thankyou-popup__button">Close</button>
</div>
